module.exports = __webpack_public_path__ + "media/application/images/checkbox-green-f12e88512760a3b9b6e517702985e789.svg";